window.cartItemArr
window.itemCount
window.selectedWarranty
window.result
window.variantsWithWarranties = []
window.offers = []
window.mwAddToButton = true

var mulberrySelectors = {
    addToCart: '#AddToCart',
    customMulberryBtn: '[data-mulberry-custom-btn]',
    cartCount: '[data-cart-count]',
    cartTotal: '[data-cart-checkout-subtotal]',
    cartSubtotal: '[data-cart-subtotal]',
    hide: 'hide',
    emptyPageContent: '[data-empty-page-content]',
    cartItem: '.cart__row',
    cartCountProductPage: '#CartCount',
    protectionAddedBtn: '[data-mulberry-protection-added-btn]',
    productForm: '[data-product-form]'
}

let pdpModalCustomBtn;

console.log('loaded');

async function findUnlimitedItem() {
    let findUnlimitedMulberry = false
    let cartContents = await fetch('/cart.js')
    let currentUnlimitedOffer = false
    cartContents = await cartContents.json()

    currentUnlimitedOffer = window.offers.find(item => item && item.duration_months === '1')
  
    if (cartContents && cartContents.items && currentUnlimitedOffer) {
        findUnlimitedMulberry = cartContents.items.find(item => item.properties && item.properties._warranty_duration_months && item.properties._warranty_duration_months === '1')
    }
    return findUnlimitedMulberry
}

async function mulberryInit() {
  console.log('init!');
    mulberry.core.isStaging = true;
    if ($(mulberrySelectors.addToCart).length === 0) {
      console.log('hide5');
        $(mulberrySelectors.customMulberryBtn).hide()
    }
    var checkbox = document.getElementById('product-terms')
    var response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
    var product = response.product;
    window.selectedVariant = product.variants.find(i => i.id == mulberryShop.selectedVariantId)

    id: window.selectedVariant.id,
        window.offers = await mulberry.core.getWarrantyOffer({
            title: product.title,
            price: window.selectedVariant.price,
            detail: product
        })

        const offersReceived = new CustomEvent("offers-received", {
          detail: {
            name: "test",
          },
        });

        document.dispatchEvent(offersReceived);

    if (window.offers.length === 0) {
        $(mulberrySelectors.customMulberryBtn).hide()
        return
    } else {
        if (await findUnlimitedItem()) {
            document.querySelector('[data-mulberry-custom-btn]').setAttribute('disabled', true)
            document.querySelector('[data-mulberry-custom-btn]').removeAttribute('style', 'color:#262D26; background-color:#FBF9F7; border-color:#262D26;')
            document.querySelector('[data-mulberry-custom-btn]').setAttribute('style', "margin-bottom: 10px;")
            $(mulberrySelectors.customMulberryBtn).hide()
            setTimeout(() => {
              $(mulberrySelectors.protectionAddedBtn).show()              
            }, 1000)
        } else {
            $(mulberrySelectors.customMulberryBtn).show()
        }
    }

    if (!checkbox) {
        document.querySelector('[data-mulberry-custom-btn]').removeAttribute('disabled')
        document.querySelector('[data-mulberry-custom-btn]').setAttribute('style', 'margin-bottom: 10px; color:#262D26; background-color:#FBF9F7; border-color:#262D26;')
    }


    console.log('init button');

    pdpModalCustomBtn = await mulberry.modal.init({
        offers: window.offers,
        settings: mulberry.core.settings,
        onWarrantySelect: async function(warranty) {
            window.result = await mulberryShop.getWarrantyVariant(warranty)
            window.selectedWarranty = warranty
            window.variantsWithWarranties.push(mulberryShop.selectedVariantId)
            $(mulberrySelectors.customMulberryBtn).hide()
            $(mulberrySelectors.protectionAddedBtn).show()
            pdpModalCustomBtn.close()
        },
        onWarrantyDecline: async function() {
            pdpModalCustomBtn.close()
        }
    })

    pdpModalAddToCartBtn = await mulberry.modal.init({
        offers: window.offers,
        settings: mulberry.core.settings,
        onWarrantySelect: async function(warranty) {
            window.result = await mulberryShop.getWarrantyVariant(warranty)
            window.selectedWarranty = warranty

            if ($('#mwAddToCart').length > 0) {
                setTimeout(async function() {
                    await mulberryShop.addWarrantyToCart(window.result.shopify_variant_id, {
                        title: product.title,
                        variantId: window.selectedVariant
                    }, window.selectedWarranty)
                    await removeAndSyncWarranties()

                }, 400)
                setTimeout(function() {
                    window.location.replace("https://shoppe.amberinteriordesign.com/cart")
                }, 700)
            } else {
                setTimeout(async function() {
                    await mulberryShop.addWarrantyToCart(window.result.shopify_variant_id, {
                        title: product.title,
                        variantId: window.selectedVariant.id
                    }, window.selectedWarranty)
                    await removeAndSyncWarranties()

                }, 400)
                window.variantsWithWarranties.push(mulberryShop.selectedVariantId)
            }

            console.log('hide2');
            $(mulberrySelectors.customMulberryBtn).hide()
            $(mulberrySelectors.protectionAddedBtn).show()
            pdpModalAddToCartBtn.close()
        },
        onWarrantyDecline: async function() {
            pdpModalAddToCartBtn.close()
            if ($('#mwAddToCart').length > 0) {
                setTimeout(function() {
                    window.location.replace("https://shoppe.amberinteriordesign.com/cart")
                }, 1000)
            }
        }
    })
  

    document.querySelector(mulberrySelectors.addToCart).addEventListener('click', addWarrantyFromAddToCartBtn)

    console.log('adding listener')
    document.querySelector(mulberrySelectors.customMulberryBtn).addEventListener('click', addWarrantyFromCustomBtn)

    async function addWarrantyFromAddToCartBtn() {
        if (window.selectedWarranty) {
            if ($('#mwAddToCart').length > 0) {
                setTimeout(async function() {
                    await mulberryShop.addWarrantyToCart(window.result.shopify_variant_id, {
                        title: product.title,
                        variantId: window.selectedVariant
                    }, window.selectedWarranty)
                    await removeAndSyncWarranties()
                }, 1500)
                setTimeout(function() {
                    window.location.replace("https://shoppe.amberinteriordesign.com/cart")
                }, 1000)
            } else {
                setTimeout(async function() {
                    await mulberryShop.addWarrantyToCart(window.result.shopify_variant_id, {
                        title: product.title,
                        variantId: window.selectedVariant.id
                    }, window.selectedWarranty)
                    await removeAndSyncWarranties()
                }, 1500)
            }
        }

        if (!window.variantsWithWarranties.includes(mulberryShop.selectedVariantId)) {
          console.log(3);
            pdpModalAddToCartBtn.open()
        }
    }

    async function addWarrantyFromCustomBtn() {
        if (!checkbox) {
            console.log(1);
            pdpModalCustomBtn.open()
        }

        if (checkbox && checkbox.checked) {
          console.log(2)
            pdpModalCustomBtn.open()
        }
    }
}


document.addEventListener('mulberry-shopify:variant-change', async function() {
    window.selectedWarranty = null
    var response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
    var product = response.product;
    window.selectedVariant = product.variants.find(i => i.id == mulberryShop.selectedVariantId)
    window.offers = await mulberry.core.getWarrantyOffer({
        id: product.id,
        title: product.title,
        price: window.selectedVariant.price,
        detail: product
    })
    const offersReceived = new CustomEvent("offers-received", {
      detail: {
        name: "test",
      },
    });

    document.dispatchEvent(offersReceived);
  console.log('EVENT DISPATCH')
  
    if (window.offers.length > 0) {
      console.log('testing');
        pdpModalAddToCartBtn.updateOffer(window.offers)
        pdpModalCustomBtn.updateOffer(window.offers)
        if (!window.variantsWithWarranties.includes(mulberryShop.selectedVariantId)) {
          console.log('hide3')
            $(mulberrySelectors.protectionAddedBtn).hide()
            $(mulberrySelectors.customMulberryBtn).show()
        } else {
            $(mulberrySelectors.protectionAddedBtn).show()
          console.log('hide4')
            $(mulberrySelectors.customMulberryBtn).hide()
        }
    }
})



async function removeAndSyncWarranties() {
    await fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
    }).then(function(cart) {
        cart.json().then(function(firstCart) {
            console.log('OK!! first cart: ', firstCart)
            mulberryShop.removeDetachedWarranty(firstCart) // Remove Warranties First 
                .then(newCart => {
                    console.log('OK!! newCart: ', newCart)
                    mulberryShop.cart.syncQuantities(newCart) // Sync Quantities Second
                        .then(newCart => {
                          console.log('OK!! newCart2: ', newCart)
                            mulberryShop.cart.render()
                            window.cartItemArrLen = newCart.items.length
                            window.itemCount = newCart.item_count

                            setTimeout(function() {
                                if (window.location.href.indexOf('/cart') !== -1) {
                                    $(mulberrySelectors.cartCount).text(newCart.item_count)
                                    $(mulberrySelectors.cartTotal).text(theme.Currency.formatMoney(newCart.total_price, theme.moneyFormatWithCurrency))
                                    $(mulberrySelectors.cartSubtotal).text(theme.Currency.formatMoney(newCart.total_price, theme.moneyFormatWithCurrency))
                                }

                                if (window.location.href.indexOf('/products') !== -1) {
                                    $(mulberrySelectors.cartCountProductPage).text('(' + newCart.item_count + ')')
                                }
                            }, 500)
                        })
                })
        })
    });
}

document.addEventListener('mulberry-shopify:warranty-added', async function(thing) {
    console.log('OK!! thing.detail.payload', thing.detail.payload);
   // if (typeof thing.detail.payload.product === 'undefined') 
    window.location.reload();
    await removeAndSyncWarranties()
})

document.addEventListener('mulberry-shopify:loaded', async function() {
    if (window.location.href.indexOf('/products') !== -1 || window.location.href.indexOf('/collections') !== -1  ) {
        await mulberryInit()
    }

    if (window.location.href.indexOf('/cart') !== -1) {
        await mulberryShop.cart.init({
            layout: {
                ctaLogo: false,
                warrantyLogo: false
            }
        })
        await mulberryShop.cart.render()
        await removeAndSyncWarranties()

        let classes = document.querySelector((mulberrySelectors.emptyPageContent)).classList.value
        setTimeout(function() {
            if (window.itemCount === 0 && classes.includes(mulberrySelectors.hide)) {
                $('form').empty()
                $(mulberrySelectors.emptyPageContent)[0].classList.remove(mulberrySelectors.hide);
            }
        }, 300)

        setupAjaxListeners()
    }
})



function setupAjaxListeners() {
    // Set up listeners to fire the pixel if/when the user peforms specific actions that trigger ajax requests.
    // Since we cant create globals we test for the XMLHttpRequest overwrite
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock fetch() in order to determine if we should mock then() as well
        var mbFetch = fetch;
        fetch = function() {
            var url = arguments[0];
            var body = '';
            if ((arguments.length > 1) && (typeof arguments[1].body !== 'undefined')) {
                body = arguments[1].body;
            }
            var promise = mbFetch.apply(this, arguments);
            if (url && url.indexOf('cart/change') !== -1) {
                //If its a product being added to cart we add a function to track it
                promise = promise.then(function(response) {
                    if (response.ok) {
                        /*removeAndSyncWarranties()
                        mulberryShop.cart.render()

                        setTimeout(function() {
                            setCartInfo()
                        }, 300) */
                    }
                    return response;
                });
            }
            return promise;
        };
    }

}


function setCartInfo() {
    for (let i = 0; i < (window.cartItemArrLen); i++) {
        let cartItem = document.querySelectorAll(mulberrySelectors.cartItem)[i]
        if (cartItem) {
            let dataSet = cartItem.dataset

            if (dataSet) {
                if (dataSet.cartItemUrl.includes('/products/mulberry-protection')) {
                    cartItem.setAttribute('style', 'display: none;')
                }
            }
        }
    }
}